// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g5n2","label":"styles_label__219L6"};